import { format } from 'date-fns';

export function convertISOToDate(ISOdate: Date) {
  return format(new Date(ISOdate), 'PPP');
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
